import ApplicationSerializer from 'cio/serializers/application';
import { ModelSchema } from 'ember-data';
import { ModelRegistry } from 'ember-data/model';

export default class FacebookLeadAdsCredentialSerializer extends ApplicationSerializer {
  normalize(type: ModelSchema<keyof ModelRegistry>, hash: Record<string, any>, prop?: string) {
    // Set static Facebook Lead Ads credentials model ID, there's only one per environment:
    if (hash) {
      hash.id = 'current';
    }

    return super.normalize(type, hash, prop);
  }
}
